import { useEffect } from "react";
function useOnScroll(target, onScroll) {
  useEffect(() => {
    if (!target) return;
    function handleOnScroll() {
      if (!target) return;
      onScroll?.({ top: target.scrollTop, left: target.scrollLeft }, target);
    }
    target.addEventListener("scroll", handleOnScroll);
    return () => {
      target.removeEventListener("scroll", handleOnScroll);
    };
  }, [target, onScroll]);
}
export {
  useOnScroll
};
//# sourceMappingURL=useOnScroll.js.map
